/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backdrop_RequiredInputs */

const en_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backdrop Required`)
};

const es_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere fondo`)
};

const fr_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toile de fond requise`)
};

const de_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund erforderlich`)
};

const ja_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景が必要です`)
};

const zh_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要设置背景`)
};

const ar_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطلوب صورة خلفية`)
};

const id_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latar Belakang Diperlukan`)
};

const it_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfondo Richiesto`)
};

const ru_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется фоновое изображение`)
};

const pt_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de Fundo Obrigatório`)
};

const ko_backdrop_required = /** @type {(inputs: Backdrop_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배경 이미지가 필요합니다`)
};

/**
* | output |
* | --- |
* | "Backdrop Required" |
*
* @param {Backdrop_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const backdrop_required = /** @type {((inputs?: Backdrop_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backdrop_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backdrop_required(inputs)
	if (locale === "es") return es_backdrop_required(inputs)
	if (locale === "fr") return fr_backdrop_required(inputs)
	if (locale === "de") return de_backdrop_required(inputs)
	if (locale === "ja") return ja_backdrop_required(inputs)
	if (locale === "zh") return zh_backdrop_required(inputs)
	if (locale === "ar") return ar_backdrop_required(inputs)
	if (locale === "id") return id_backdrop_required(inputs)
	if (locale === "it") return it_backdrop_required(inputs)
	if (locale === "ru") return ru_backdrop_required(inputs)
	if (locale === "pt") return pt_backdrop_required(inputs)
	return ko_backdrop_required(inputs)
});